<template>
  <div class="box">
    <StepTitle step-num="3" title="设置签名" />
    <el-form :model="ruleForm" size="small" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="特殊字体">
        <el-radio-group v-model="ruleForm.font">
          <el-radio label="hwxk">华文行楷</el-radio>
          <el-radio label="mbxs">毛笔行书</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="预览">
        <p class="preview" :style="{'font-family': ruleForm.font}">{{ruleForm.name}}</p>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
      </el-form-item>
    </el-form>
    <canvas v-show="false" class="myCanvas" ref="canvas" width="473" height="270"></canvas>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {dataURLtoFile} from '@/utils/tools';
import StepTitle from '@/components/step-title.vue';
export default {
  components: {
    StepTitle
  },
  data() {
    return {
      ruleForm: {
        name: '',
        font: 'hwxk'
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
      },
      imageData: '',
      applySignFormData: new FormData(),
    }
  },
  computed: {
    ...mapGetters({
      name: "setSign/name",
      generatedUserId: "setSign/generatedUserId"
    })
  },
  created() {
    this.ruleForm.name = this.name;
  },
  mounted() {
    // this.init()
  },
  methods: {
    init() {
      let canvas = this.$refs.canvas;
      this.ctx = canvas.getContext('2d');
      this.ctx.globalAlpha = 0;
      this.ctx.fillStyle = "#fff";
      this.ctx.fillRect(0,0, canvas.width, canvas.height);
      this.ctx.globalAlpha = 1;
      this.ctx.font = `120px ${this.ruleForm.font}`;
      this.ctx.fillStyle = "#0f63de";
      this.ctx.textAlign = "center";
      this.ctx.textBaseline = "middle";
      this.ctx.fillText(this.ruleForm.name, 230, 130);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.init();
          this.imageData = this.$refs.canvas.toDataURL("image/png", 1.0);
          let file = dataURLtoFile(this.imageData, '签名图片');
          this.applySignFormData.append("file", file);
          this.applySignFormData.append("userId", this.generatedUserId);
          this.$api.applySign(this.applySignFormData).then(res => {
            if (res.data.code === '200') {
              this.$message({
                message: '签名设置成功',
                type: 'success'
              });
              this.$router.replace({
                path: '/user/list'
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              });
            }
          }).finally(() => {
            this.applySignFormData = new FormData();
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>
<style lang="less" scoped>
.box {
  width: 500px;
  // margin-top: 20px;
}
.ttf{
  font-size: 50px;
  font-family: 'hwxk';
}
.myCanvas{
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0);
}
.preview{
  font-size: 40px;
  color: #0f63de;
}
.ruleForm{
  width: 420px;
}
</style>